// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"AssetUpdatePartnerModal-module__dropdown___1PvV1","errorText":"AssetUpdatePartnerModal-module__errorText___2tbK0"};